/**
 * @file: ErpEmployeeRole.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ErpEmployeeRole {
  ServiceAgent = 'service_agent',
  Technicians = 'technicians',
}

export const ErpEmployeeRoleValueSet = new Set([
  ErpEmployeeRole.ServiceAgent,
  ErpEmployeeRole.Technicians,
]);
